export default __webpack_public_path__ + "static/media/nomad.fdf80c6f.svg";